module.exports = __webpack_public_path__ + "img/site.1ce2a298.png";